<template>
  <div class="container table-responsive">

    <BuyerInfo ref="buyerInfoRef"
        @onClose="handleBIOnClose"
    />

    <div class="row">
      <div class="col-6">
        <button class="btn btn-warning pull-left" @click="saveShoppingCartLocal">
          <i class="fa fa-angle-left"></i> Back to Shopping
        </button>
      </div>
      <!-- <div class="col-6 text-right">
        <a v-if="orgName" href="https://ketco-irons.com" target="_blank" class="navbar-brand font-weight-bold">{{ orgName }}</a>
      </div> -->
    </div>
    <br>
    <table id="cart" class="table table-hover table-sm">
      <thead>
        <tr>
          <th style="width:50%">Product</th>
          <th v-if="showPrices" style="width:10%">Price</th>
          <th style="width:8%">Quantity</th>
          <th v-if="showPrices" style="width:22%" class="text-center">Subtotal</th>
          <th style="width:10%"></th>
        </tr>
      </thead>

      <transition-group name="list-shopping-cart" tag="tbody">
        <app-cart-item
          v-for="cartItem in cartItemList"
          :cartItem="cartItem"
          :key="cartItem.name"
        ></app-cart-item>
      </transition-group>

      <tfoot>
        <tr>
          <td></td>
          <td v-if="showPrices"></td>
          <td v-if="showPrices" class="text-right"><strong>Total</strong></td>
          <td v-if="showPrices" class="text-center"><strong> {{ cartValue.toFixed(2) }}</strong></td>
          <td></td>
        </tr>

      </tfoot>
    </table>
    <hr>

    <div>
      <div v-if="showPrices" class="row" style="color:red;font-size:12px;">
        **Final total may vary based on Taxes, Delivery & Other charges.
      </div>
      <br>
      <div class="row">
        <div class="col-sm-4"></div>
        <button :disabled="cartValue==0" 
              class="btn btn-success col-sm-4" @click="checkout">
          Request Information
        </button>
        <div class="col-sm-4"></div>
      </div>
      <br>      
    </div>

    <div v-if="showWholesalersFlag">
      <p class="font-weight-bold text-center">Please contact wholesalers in your state</p>

      <table id="cart" class="table table-hover table-sm">
        <thead>
          <tr>
            <th style="width:30%">Name</th>
            <th style="width:10%">Phone</th>
            <th style="width:60%">Address</th>
          </tr>
        </thead>

        <tbody>
          <tr v-for="wholesaler in wholesalerList" :key="wholesaler.name">
          <td>{{ wholesaler.name }}</td>  
          <td>{{ wholesaler.phone }}</td> 
          <td>{{ wholesaler.address }}</td>  
        </tr>
        </tbody>

        <tfoot>
        </tfoot>
      </table>
        
      <hr>
      <h6>{{ message }}</h6>
    </div>

  </div>
</template>

<script>
import { mapActions, mapGetters } from 'vuex'
import CartItem from './cart/CartItem.vue'
import { anonSignIn, getNotificationToken } from '../config/firebaseConfig'
import axios from "axios"
import BuyerInfo from './common/BuyerInfo.vue'
import { DB } from '../config/firebaseConfig'
import { collection, query, where, orderBy, limit, getDocs } from "firebase/firestore"


export default {
  computed: {
    ...mapGetters([
      'cartItemList',
      'isLoggedIn',
      'products',
      'currentUser',
      'cartValue',
      'orgId',
      'buyer',
      'orgName',
      'showPrices',
      'dealerClassLevel',
      'dealerOrderLevel'
    ]),
  },
  components: {
    appCartItem: CartItem,
    BuyerInfo
  },


  data () {
    return {
      message: '',
      wholesalerList: [],
      showWholesalersFlag: false,

      //buyer: {'name': '', 'state': '', 'phone': ''},
      // stateList: ["Andhra Pradesh","Andaman and Nicobar Islands","Arunachal Pradesh","Assam","Bihar",
      //             "Chandigarh","Chhattisgarh","Dadar and Nagar Haveli","Daman and Diu","Delhi","Lakshadweep",
      //             "Puducherry","Goa","Gujarat","Haryana","Himachal Pradesh","Jammu and Kashmir","Jharkhand",
      //             "Karnataka","Kerala","Madhya Pradesh","Maharashtra","Manipur","Meghalaya","Mizoram",
      //             "Nagaland","Odisha","Punjab","Rajasthan","Sikkim","Tamil Nadu","Telangana","Tripura",
      //             "Uttar Pradesh","Uttarakhand","West Bengal"],
    }
  },

  mounted() {
    this.showWholesalersFlag = false
  },

  methods: {
    ...mapActions([
      'saveShoppingCart',
      'addMessage',
      'saveToTransaction',
      'clearCart',
      'submitOrder',
      'setBuyer',
      'authStatusChange'
    ]),


    checkValidCart(itemList, prodList) {
      let isValid = true
      let message = ''

      itemList.map((item) => {
        for (let prodIdx = 0; prodIdx < prodList.length; prodIdx++) {
          if (prodList[prodIdx].id == item.id) {
            if (prodList[prodIdx].quantity < item.quantity) {
              message = `Only ${prodList[prodIdx].quantity} ${item.title} available in stock`
              isValid = false
              return
            }
            break
          }
        }
      })
      return {
        isValid,
        message,
      }
    },
    saveShoppingCartLocal() {
      this.$router.push('/' + this.orgId)
      return
    },

    checkout() {
        if (!this.cartItemList || this.cartItemList.length == 0) {
          this.addMessage({messageClass: 'warning', message: 'Your cart is empty!',})
          return
        }
        else {
          this.$refs.buyerInfoRef.openModal()
        }
    },

    async handleBIOnClose(name, phone, state){
      var self = this
      if (name.trim() == '' || phone.trim() == '' ){
        self.addMessage({messageClass: 'warning', message: 'Missing Buyer Information!',})
          return
      }
      else {
        this.buyer.name = name
        this.buyer.phone = phone
        this.buyer.state = state
        if (this.cartValue > this.dealerOrderLevel)
          self.submitOrder()
        else{
          self.showWholesalers(this.buyer.state)
          self.showWholesalersFlag = true
        }
      } 

    },

    //Show wholesalers from db
    async showWholesalers(stateSel){
      var self = this
      self.wholesalerList = []
      self.message = ''
      let state = stateSel.toLowerCase()

      const tokens = await anonSignIn()
      if (tokens.auth == ''){
        self.addMessage({messageClass: 'error', message: "Invalid User",})
        return
      } else {
        self.authStatusChange()
      }

      const q = query(collection(DB, "Org", self.orgId, "CustomerOrders"), 
                      where("state", "==", state), 
                      orderBy("amt", "desc"),
                      limit(10)
                      );

      const querySnapshot = await getDocs(q)
      await querySnapshot.forEach((doc) => {
        if (doc.data().amt > this.dealerClassLevel)
          self.wholesalerList.push({'name': doc.data().customer, 'phone': doc.data().phone, 'address': doc.data().address})
      })
      if (self.wholesalerList.length==0)
        self.message = "No wholesalers found in this state."

    },

    async submitOrder() {
	      this.addMessage({messageClass: "warning", message: "Please wait, processing..."})

        let cartItemList = this.cartItemList 
        let cartValue = this.cartValue
        let orgId = this.orgId 
        let buyer = this.buyer

        var partner = 
        {
          nbr: '',
          type: 'Customer',
          name: buyer.name,
          phone: buyer.phone,
          GSTN: '',
          state: buyer.state,
          inState: 'No',
          address1: '',
          address2: '',
          address3: '',
          transporter: '',
          transportDest: '',
          note: '',
          vgtSelected: false
        }

        // Create Order Object
        var order = {
          'nbr': null,
          'type': 'Sale',
          'location': 'Online',
          'items': [],
          'status': 0,
          'note': '',
          'tax': 0,
          'total': cartValue,
          'total1': cartValue,
          'total2': 0,
              'invoiceIssued': 'No',
              'GSTN': '',
              'altNbr': '',
          'inState': 'No',
          'createDate': null,
          'paid': 'No',
          'invoiceDate': null,
          'curPayDate': null,
          'curPayType': 'Bank',
          'curPayAmt': 0,
          'payInstructions': '',
          'payments': [],
          'paidSoFar': 0,
          'outstanding': 0,
          'delivered': 'No',
          'deliveryDate': null,
          'deliveryReady': 'No',
          'cancelled': 'No',
          'cancelledDate': null,
          'updateDate': null,
          'partner': partner,
          }

        var currentDate = new Date()
        currentDate.setHours(12)
        currentDate.setMinutes(0)
        currentDate.setSeconds(0)
        currentDate.setMilliseconds(0)
        order.createDate = currentDate
        order.updateDate = currentDate

        // Add Items
        var items = []
        var orderTax = 0
        var orderTotal = 0
        for (let i = 0; i < cartItemList.length; i++) {
          let item = {}
          item.name = cartItemList[i].name
          item.item1Name = cartItemList[i].item1Name
          item.price = cartItemList[i].price
          item.cost = 0
          item.qty = cartItemList[i].quantity
          item.tax = (cartItemList[i].price * (cartItemList[i].taxrate / 100) * cartItemList[i].quantity)
          item.tax = parseFloat(item.tax.toFixed(2))
          item.surcharge = 0
          item.discount = 0
          item.minSalesTax = 0
          item.total = (cartItemList[i].price * (1 + cartItemList[i].taxrate / 100) * cartItemList[i].quantity)
          item.total = parseFloat(item.total.toFixed(2))
          item.CGST = {'amt': 0, 'apply': 'No'}
          item.SGST = {'amt': 0, 'apply': 'No'}
          item.IGST = {'amt': item.tax, 'apply': 'Yes'}
          orderTax = orderTax + item.tax
          orderTotal = orderTotal + item.total
          items.push(Object.assign({}, item))
        }
        order['items'] = items
        order['tax'] = orderTax
        order['total'] = orderTotal

        const authToken = await anonSignIn()
        if (!authToken){
          self.addMessage({messageClass: 'error', message: "Invalid User",})
          return
        }
        const nToken = await getNotificationToken()

        const postJson = {
          'orgId': orgId,
          'order': order,
          'nToken': nToken,
          'buyerName': this.buyer.name,
          'buyerPhone': this.buyer.phone
        }

        var self = this

        axios({
          method: 'POST',
          baseURL: process.env.VUE_APP_ROOT_API,
          url: '/SaveOrderOnline/',
          data: postJson,
          headers: {
            'Authorization': 'Bearer ' + authToken,
            'OrgId': self.orgId,
            'Content-Type': 'application/json',
          },
        })
        .then(function (response) {
          if (response.data.err != ''){
            self.addMessage({messageClass: "warning", message: response.data.err})
          }
          else {
            //self.addMessage({messageClass: "success", message: "Order Submitted. Seller will contact you soon."})
            // Clear Shopping Cart
            //self.clearCart()
            // Clear Buyer
            //this.setBuyer('', '', '')
          }
        })
        .catch(function (error) {
          self.addMessage({messageClass: "danger", message: String(error)})
        })

    },

  },
}
</script>

<style lang="scss" scoped>
.list-shopping-cart-leave-active {
  transition: all 0.4s;
}

.list-shopping-cart-leave-to {
  opacity: 0;
  transform: translateX(50px);
}

.table-sm {
  font-size: 0.875rem;
  ::v-deep h4 {
    font-size: 1.25rem;
  }
}


</style>
